import blog1 from  '../img/blogs/1.png';
import blog2 from  '../img/blogs/2.png';
import blog3 from  '../img/blogs/3.jpg';
import blog4 from  '../img/blogs/4.jpeg';

const blogs = [
    {
        id: 1,
        title: 'React fundamentals',
        link: `https://aa-nadim.medium.com/react-fundamentals-bda4f5907728`,
        date: '08',
        month: 'May',
        image: blog1
    },
    {
        id: 2,
        title: 'JavaScript latest features',
        link: `https://medium.com/important-topics-of-javascript/javascript-latest-features-and-website-analysis-93304ac88a4b`,
        date: '03',
        month: 'May',
        image: blog2
    },
    {
        id: 3,
        title: 'JavaScript Interview Questions',
        link: `https://aa-nadim.medium.com/top-10-javascript-interview-questions-8bed29e8108`,
        date: '09',
        month: 'May',
        image: blog3,
    },
    {
        id: 4,
        title: 'Important topics of JavaScript that you have to learn.',
        link: `https://medium.com/important-topics-of-javascript/important-topics-of-javascript-that-you-have-to-learn-7b96c274bea7`,
        date: '05',
        month: 'May',
        image: blog4
    }
]

export default blogs;